import type { ReactNode } from 'react'
import { Icon, type IconName } from './Icon.js'

interface EmptyProps {
  icon?: IconName
  title: string
  description?: ReactNode
  action?: ReactNode
  className?: string
}

export function Empty({
  icon = 'inbox',
  title,
  description,
  action,
  className = '',
}: EmptyProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center px-6 py-12 ${className}`}
    >
      <span className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-surface-subtle text-fg-subtle">
        <Icon name={icon} size={20} />
      </span>
      <p className="text-sm font-medium text-fg">{title}</p>
      {description ? (
        <p className="mt-1 max-w-sm text-sm text-fg-muted">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
